
import fire from "_utils/firebase";
import { getAuth, sendEmailVerification } from 'firebase/auth';

export const getToken = async () => {
  return new Promise((resolve, reject) => {
    if (fire.auth().currentUser) {
      fire
        .auth()
        .currentUser.getIdToken()
        .then((token) => {
          resolve(token);
        })
        .catch((error) => {
          reject(new Error("error getting token", error));
        });
    }
  });
};

export const lastNotificationRead = async (userId) => {
  const url = `/api/v1/mobileusers/portalusers/${userId}/lastNotificationRead`;

  return new Promise(async (resolve, reject) => {
    try {
      // make request
      const token = await getToken();
      const response = await fetch(url, {
        method: "PUT",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });
      // handle response
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad details");
      } else {
        resolve(json);
      }
    } catch (e) {
      reject(new Error("error getting user info"));
    }
  });
};


// getPosts
export const getPosts = async () => {

  const url = `/api/v1/mobileusers/updates/`;

  return new Promise(async (resolve, reject) => {
    try {
      // make request
      const token = await getToken();
      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          "Content-Type": "application/json",
          "firebase-uid": token,
        },
      });
      // handle response
      let json = await response.json();
      if (response.status >= 400 && response.status < 600) {
        throw new Error("Bad details");
      } else {
        resolve(json);
      }
    } catch (e) {
      reject(new Error("error getting user info"));
    }
  });
};
